<!--
 * Created by JackCui on 2021/9/17
 -->
<template>
  <el-dialog
    class="popup-container"
    modal
    :width="sizeView.width"
    :visible.sync="visible"
    :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    v-bind="{...$attrs}"
    @close="cancel"
    @open="opened"
  >
    <div class="dialog-wrap" v-scrollbarPrettify>
      <slot/>
    </div>
    <div
      v-if="$slots.title"
      slot="title"
    >
      <slot name="title"/>
    </div>
    <div
      v-if="$slots.footer"
      slot="footer"
    >
      <slot name="footer"/>
    </div>
  </el-dialog>
</template>

<script>
  import scrollbarPrettify from '../../../directives/scrollbar-prettify'

  const sizeMap = {
    'large': {
      width: '1080px',
      height: '600px'
    },
    'medium': {
      width: '900px',
      height: '520px'
    },
    'small': {
      width: '520px',
      height: '280px'
    },
    'hidden': {
      width: '0',
      height: '0'
    }
  }

  export default {
    name: 'sy-popup',
    model: {
      prop: 'visible',
      event: 'visible-change'
    },
    components: {},
    directives: {
      scrollbarPrettify
    },
    props: {
      // 切换显示隐藏
      visible: Boolean,
      // 弹窗大小 三种类型
      size: {
        type: String,
        // large / medium / small
        default: 'medium'
      },
      title: String
    },
    data () {
      return {}
    },
    computed: {
      sizeView () {
        return sizeMap[this.size]
      }
    },
    methods: {
      close () {
        this.$emit('visible-change', false)
        this.$emit('close')
      },
      open () {
        this.$emit('visible-change', true)
        this.$emit('open')
      },
      cancel () {
        this.close()
      },
      opened () {
        this.open()
      },
      confirm () {
        this.$emit('confirm')
      }
    },
    destroyed () {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
    }
  }
</script>

<style scoped lang="scss">
  .popup-container {
    display:flex;
    justify-content:center;
    align-items:center;
  }

  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    overflow: hidden;

    div.el-dialog__header {
      height: 42px;

      .el-dialog__title {
        font-weight: 500;
      }

      .el-dialog__headerbtn {
        font-size: 14px;
        top: 11px;
      }
    }

    div.el-dialog__body {
      padding: 32px 20px;
    }

    div.el-dialog__footer {
      text-align: right;
      padding: 12px 24px;
      border-top: 1px solid #ECEFF2;

      .sy-button-gallery-wrap {
        margin-bottom: 0 !important;
      }
    }
  }

  .size-large {
    ::v-deep .el-dialog {
      width: 1040px;
    }
  }

  .size-medium {
    ::v-deep .el-dialog {
      width: 840px;
    }
  }

  .size-small {
    ::v-deep .el-dialog {
      width: 520px;
    }
  }

  .dialog-wrap {
    overflow: auto;
    max-height: calc(90vh - 164px);

    ::v-deep .mod-group-wrap {
      border: none;
      box-shadow: none;
      padding-top: 16px;
    }

    ::v-deep .mod-group-wrap:nth-of-type(1) {
      padding-top: 0;
    }

    ::v-deep .tab-pane .mod-group-wrap {
      padding-top: 16px;
    }
  }
</style>
